import http from './http.service';

class TasksService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/tasks";
    }

    complete(data) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .put(`${this.baseUrl}/complete`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    confirm(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .put(`${this.baseUrl}/confirm/${id}`);
    }

    create(data) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .post(`${this.baseUrl}/create`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    edit(data) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .post(`${this.baseUrl}/edit`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    delete(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .delete(`${this.baseUrl}/${id}`);
    }

    decline(id, reason, assignee) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.put(`${this.baseUrl}/decline`, { id, reason, assignee });
    }

    getAssignToMe() { }

    getCreatedByMe() { }

    return(id, reason) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.put(`${this.baseUrl}/return`, { id, reason });
    }

    start(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .put(`${this.baseUrl}/start/${id}`);
    }

    archive(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .put(`${this.baseUrl}/archive/${id}`);
    }

    unarchive(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .put(`${this.baseUrl}/unarchive/${id}`);
    }

    restart(data) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .put(`${this.baseUrl}/restart`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    expand(data) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .put(`${this.baseUrl}/expand`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    getHistory(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/history/${id}`);
    }

    getTaskResult(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/result/${id}`);
    }

    getDetailsById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/detailsById/${id}`);
    }
}

export default new TasksService();
